import MaintenanceEmail from ".";

export const maintenanceEmailRoutes = [
  {
    path: "/maintenanceEmail",
    element: <MaintenanceEmail />,
  },
];
